import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ filters, onFilterChange, onReset }) => {
  const propertyTypes = [
    { value: 'all', label: 'Tous les types' },
    { value: 'apartment', label: 'Appartement' },
    { value: 'house', label: 'Maison' },
    { value: 'villa', label: 'Villa' },
    { value: 'office', label: 'Bureau' },
    { value: 'commercial', label: 'Commercial' }
  ];

  const categories = [
    { value: 'all', label: 'Toutes catégories' },
    { value: 'rent', label: 'Location' },
    { value: 'sale', label: 'Vente' }
  ];

  const locations = [
    { value: 'all', label: 'Tous les quartiers' },
    { value: 'gombe', label: 'Gombe' },
    { value: 'ngaliema', label: 'Ngaliema' },
    { value: 'limete', label: 'Limete' },
    { value: 'bandalungwa', label: 'Bandalungwa' },
    { value: 'kalamu', label: 'Kalamu' },
    { value: 'lemba', label: 'Lemba' }
  ];

  const bedroomOptions = [
    { value: 'all', label: 'Toutes chambres' },
    { value: '1', label: '1 chambre' },
    { value: '2', label: '2 chambres' },
    { value: '3', label: '3 chambres' },
    { value: '4', label: '4+ chambres' }
  ];

  const statusOptions = [
    { value: 'all', label: 'Tous statuts' },
    { value: 'available', label: 'Disponible' },
    { value: 'rented', label: 'Loué' },
    { value: 'reserved', label: 'Réservé' }
  ];

  return (
    <div className="bg-white/80 dark:bg-slate-800/40 backdrop-blur-xl border border-slate-200 dark:border-white/10 rounded-3xl shadow-2xl p-4 md:p-6 lg:p-8 mb-6 md:mb-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl md:text-2xl font-semibold text-slate-900 dark:text-white flex items-center gap-2">
          <Icon name="Filter" size={24} className="text-blue-400" />
          Filtres de recherche
        </h2>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onReset}
          className="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-slate-800"
        >
          Réinitialiser
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        <Select
          label="Type de propriété"
          options={propertyTypes}
          value={filters?.type}
          onChange={(value) => onFilterChange('type', value)}
        />

        <Select
          label="Catégorie"
          options={categories}
          value={filters?.category}
          onChange={(value) => onFilterChange('category', value)}
        />

        <Select
          label="Quartier"
          options={locations}
          value={filters?.location}
          onChange={(value) => onFilterChange('location', value)}
          searchable
        />

        <Select
          label="Chambres"
          options={bedroomOptions}
          value={filters?.bedrooms}
          onChange={(value) => onFilterChange('bedrooms', value)}
        />

        <Select
          label="Statut"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Input
          label="Prix maximum (CDF)"
          type="number"
          placeholder="Ex: 5000000"
          value={filters?.maxPrice}
          onChange={(e) => onFilterChange('maxPrice', e?.target?.value)}
        />

        <Input
          label="Surface min (m²)"
          type="number"
          placeholder="Ex: 100"
          value={filters?.minArea}
          onChange={(e) => onFilterChange('minArea', e?.target?.value)}
        />

        <Input
          label="Surface max (m²)"
          type="number"
          placeholder="Ex: 500"
          value={filters?.maxArea}
          onChange={(e) => onFilterChange('maxArea', e?.target?.value)}
        />

        <div className="flex items-end">
          <Button
            variant="default"
            fullWidth
            iconName="Search"
            iconPosition="left"
            onClick={() => onFilterChange('apply', true)}
          >
            Rechercher
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;
